<template>
  <div class>
    <button
      @click="initMethods()"
      class="btn btn-primary"
      style="display: none"
    >
      Save
    </button>

    <modal-publish-free-component
      :domain="domainToShow"
      :show="modalPublishFree.show"
      @upgrade="upgradePlan"
      @closeAction="closePublishFreeModal"
    ></modal-publish-free-component>

    <modal-save-component
      :url_upgrade="urlUpgrade"
      :show="saveModal.show"
      :isFree="'1'"
      @upgradeClick="updagraAction"
      @closeAction="closeSaveModalAction"
    ></modal-save-component>
    <modal-upgrade-wait-component
      :show="upgradeModal.show"
      @upgrade="openDomainModal"
      @closeAction="closeUpgradeModalAction"
    ></modal-upgrade-wait-component>
    <modal-domain-component
      :id_website="id_website"
      @updateDomain="updateWebsite"
      :show="domainModal.show"
      @closeAction="closeDomainModalAction"
      @connect="connectDomain"
    ></modal-domain-component>
    <modal-domain-connected-component
      :show="domainConnectedModal.show"
      @closeAction="closeDomainConnectedModal"
    ></modal-domain-connected-component>
    <modal-publish-finish-component
      :domain="domainToShow"
      :show="modalPublishFinish.show"
      @closeFinish="closePublishFinishModal"
      @changeDomainAction="changeDomain"
    ></modal-publish-finish-component>
    <modal-initial-component
      :show="modalInitial.show"
      :site_id="id_website"
      @closeInitial="closeInitialModal"
    ></modal-initial-component>
  </div>
</template>

<script>
import ModalSaveComponent from "./ModalSave.vue";
import ModalUpgradeWaitComponent from "./ModalUpgrade.vue";
import ModalDomainComponent from "./ModalDomain.vue";
import ModalDomainConnectedComponent from "./ModalDomainConnected.vue";
import ModalPublishFinishComponent from "./ModalPublishFinish.vue";
import ModalPublishFreeComponent from "./ModalPublishFree.vue";
import ModalInitialComponent from "./ModalInitial.vue";

import { get as getWebsiteData } from "../../../js/services/editor/website";
import { getUser as getUserData } from "../../../js/services/user";
import axios from "axios";

export default {
  name: "SaveWebsiteComponent",
  props: ["type", "show", "id_layout", "id_website"],
  components: {
    ModalSaveComponent,
    ModalUpgradeWaitComponent,
    ModalDomainComponent,
    ModalDomainConnectedComponent,
    ModalPublishFinishComponent,
    ModalPublishFreeComponent,
    ModalInitialComponent,
  },
  watch: {
    show: function (value) {
      if (value) {
        if (this.type === "save") {
          this.getWebsite();
        }

        if (this.type === "connect") {
          this.domainModal.show = 1;
        }
      } else {
      }
    },
  },
  data() {
    return {
      saveModal: {
        show: 0,
      },
      upgradeModal: {
        show: 0,
      },
      domainModal: {
        show: 0,
      },
      domainConnectedModal: {
        show: 0,
      },
      modalPublishFinish: {
        show: 0,
      },
      modalPublishFree: {
        show: 0,
      },
      modalInitial: {
        show: 0,
      },
      websiteData: {},
      userData: {},
      domainToShow: "",
      urlUpgrade:
        "https://builderall.com/builder-plan?return-cheetah=1&go-to-purchase-domain=1",
    };
  },
  computed: {
    officeUrl() {
      return typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com"
    }
  },
  methods: {
    getWebsite() {
      getWebsiteData(this.id_website).then((res) => {
        this.websiteData = res.data;
        this.getUser();
        this.domainShow(this.websiteData);
      });
    },

    updateWebsite() {
      getWebsiteData(this.id_website).then((res) => {
        this.websiteData = res.data;
        this.domainShow(this.websiteData);
      });
    },

    getUser() {
      getUserData().then((res) => {
        this.userData = res.data.user;
        /**
         * se usuario está no plano free, passa por todas as modais
         */
        if (res.data.user.is_free == 1) {
          this.modalPublishFree.show = 1;
        } else {
          /**
           * se usuario não está no plano free, analisar se o website tem ou não dominio
           */

          if (this.websiteData.dominio != "") {
            this.modalPublishFinish.show = 1;
          } else {
          }
        }
      });
    },

    domainShow(config) {
      if (this.$store.state.user && this.$store.state.user.user_domain) {
        let premiunDomain = typeof process.env.PREMIUN_DOMAIN !== 'undefined' ? process.env.PREMIUN_DOMAIN : '.site.builderallsite.com';

        this.domainToShow = config.access_url.replace(
          premiunDomain,
          ".preview.heythisworks.com"
        );
      } else {
        this.domainToShow = config.access_url;
      }
    },

    initMethods() {
      if (this.action === "save") {
        this.modalPublishFree.show = 1;
      }

      if (this.action === "connect") {
        this.domainModal.show = 1;
      }
    },

    upgradePlan() {
      var emailUser = this.userData.email;
      var vm = this;

      if (emailUser == "teste.geo@gmail.com") {
        emailUser = "final@builderall.com";
      }

      this.modalPublishFree.show = 0;
      axios
        .get(
          `${this.officeUrl}/us/office/account-exists?email=${emailUser}`,
          { headers: { "X-Requested-With": "XMLHttpRequest" } }
        )
        .then((res) => {
          if (res.data.is_free) {
            if (
              typeof res.data.upgrade_url !== "undefined" &&
              res.data.upgrade_url !== null
            ) {
              vm.urlUpgrade = res.data.upgrade_url;
            }

            vm.saveModal.show = 1;
          } else {
            vm.domainModal.show = 1;
          }
        })
        .catch((error) => {
          vm.urlUpgrade =
            "https://builderall.com/builder-plan?return-cheetah=1&go-to-purchase-domain=1";
          vm.saveModal.show = 1;
        });
    },

    updagraAction() {
      this.upgradeModal.show = 1;
    },

    closePublishFreeModal() {
      this.modalPublishFree.show = 0;
      this.$emit("closeAction");
    },

    closeSaveModalAction() {
      this.saveModal.show = 0;
      this.$emit("closeAction");
    },

    closeUpgradeModalAction() {
      this.upgradeModal.show = 0;
      this.$emit("closeAction");
    },

    openDomainModal() {
      this.domainModal.show = 1;
    },

    closeDomainModalAction() {
      this.domainModal.show = 0;
      this.$emit("closeAction");
    },

    connectDomain(domain) {
      this.closeDomainModalAction();
      this.openDomainConnectedModal();
    },

    openDomainConnectedModal() {
      this.domainConnectedModal.show = 1;
    },

    closeDomainConnectedModal() {
      this.domainConnectedModal.show = 0;
      this.modalPublishFinish.show = 1;
    },

    closePublishFinishModal() {
      this.modalPublishFinish.show = 0;
      this.$emit("closeAction");

      if (!this.websiteData.layouts[0].pages.find((page) => page.initial))
        this.openInitialModal();
    },

    openInitialModal() {
      this.modalInitial.show = 1;
    },

    closeInitialModal() {
      this.modalInitial.show = 0;
    },

    changeDomain() {
      this.modalPublishFinish.show = 0;
      this.domainModal.show = 1;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
/deep/ .popup-save-title {
  margin-top: 50px;
  font: Bold 20px/26px Muli;
  color: #434343;
  font-size: 20px;
}

/deep/ .popup-save-message {
  color: #5a5959;
  margin-top: 30px;
  font: Regular 18px/25px Lato;
  font-size: 18px;
}

/deep/ .popup-save-action {
  color: #5a5959;
  margin-top: 30px;
  font: Bold 18px/25px Lato;
  letter-spacing: 0;
  font-size: 18px;
}

/deep/ .popup-save-btn-upgrade {
  margin-top: 30px;
  margin-bottom: 30px;
  background: #7400fc 0% 0% no-repeat padding-box;
  border-color: #7400fc;
  box-shadow: 0px 3px 2px #1e120d1a;
  height: 88px;
  border-radius: 5px;
  font: Bold 26px/16px Muli !important;
  letter-spacing: 0.78px;
  font-size: 26px;
}

/deep/ .button-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .btn-publish,
.btn-not-now {
  font-size: 13px;
  font-family: Muli;
  font-weight: 800;
  letter-spacing: 0.39px;
  text-transform: uppercase;
}

/deep/ .loading-gif {
  margin-top: 30px;
  margin-bottom: 30px;
  height: 88px;
  width: 100%;
  border-radius: 5px;
  background: #fff 0% 0% no-repeat padding-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .btn-disabled {
  opacity: 0.3;
}

/deep/ .popup-save-btn-buy-domain {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 30px;
  background: #7400fc 0% 0% no-repeat padding-box;
  border-color: #7400fc;
  box-shadow: 0px 3px 2px #1e120d1a;
  height: 44px;
  border-radius: 5px;
  font-family: "Muli";
  letter-spacing: 0.78px;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/SaveWebsiteComponent.vue